"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkActionsService = void 0;
class BulkActionsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Add a new bulk action
     * @param requestBody
     * @returns BulkActionResponse
     * @throws ApiError
     */
    createBulkAction(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/bulk-action',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all bulk actions
     * @param payload
     * @param page
     * @param count
     * @returns BulkActionsResponse
     * @throws ApiError
     */
    getBulkActions(payload, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bulk-action',
            query: {
                'payload': payload,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Get bulk action by id
     * @param id
     * @returns BulkActionResponse
     * @throws ApiError
     */
    getBulkAction(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bulk-action/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get bulk action by id and then get signed url for exported file
     * @param id
     * @returns GetFileSignedUrlResponse
     * @throws ApiError
     */
    getBulkActionExportedFileSignedUrl(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bulk-action/{id}/signed-url',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get bulk action entries by action id
     * @param id
     * @param page
     * @param count
     * @returns BulkActionEntriesResponse
     * @throws ApiError
     */
    getBulkActionEntries(id, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bulk-action/entries/{id}',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Download the errors when processing a bulk action as csv.
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    downloadBulkActionErrorsById(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bulk-action/{id}/errors-download',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Place the entries pending processing into the queue again.
     * @param id
     * @returns FileProcessResponse
     * @throws ApiError
     */
    replayBulkActionById(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/bulk-action/{id}/replay',
            path: {
                'id': id,
            },
        });
    }
}
exports.BulkActionsService = BulkActionsService;
